<template>
  <div class="grm-snackbar"
       :data-snackbar-id="snackbar.id"
       :class="[
         grmSnackbarClass,
         'p-4 rounded-lg flex items-start absolute overflow-hidden transition-all duration-300 pointer-events-auto'
       ]"
       :style="grmSnackbarStyle"
       @click="showAllMessage"
  >
    <div class="w-full h-0.5 absolute top-0 right-0 left-0"
         ref="duration"
         :class="durationClass"
         :style="durationStyle"
    ></div>
    <div v-if="!snackbar.hideIcon" class="h-6 mr-2 flex items-center">
      <GrmIcon :icon="snackbar.type"
               :class="[
                 isShowAllMessage ? 'self-baseline mt-px' : ''
               ]"
      />
    </div>
    <span class="sr-only">{{ snackbar.type }}</span>
    <p ref="message"
       :class="[
         messageClass,
         { 'whitespace-normal': isShowAllMessage },
         'min-w-0 text-sm leading-6 font-medium flex items-center flex-1 w-min truncate'
       ]"
       v-html="snackbar.message"
    ></p>
    <GrmCloseBtn notShowTooltip
                 class="ml-1"
                 :color="snackbar.type"
                 :class="[
                   closeBtnClass,
                   { 'self-baseline': isShowAllMessage }
                 ]"
                 @click="close"
    />
  </div>
</template>

<script>
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn";
import GrmIcon from "@/components/Common/icon/GrmIcon";
import {Device} from "@/utils";

export default {
  name: 'GrmSnackbar',
  components: {
    GrmIcon,
    GrmCloseBtn
  },
  props: {
    isOpenExtendMenu: { type: Boolean, required: true },
    snackbar: { type: Object, required: true },
    snackbars: { type: Object, required: true },
    index: { type: Number, required: true },
  },
  data() {
    return {
      isShowAllMessage: false,
    }
  },
  computed: {
    durationStyle() {
      return {
        transition: `transform ${this.snackbar.duration}ms linear`,
        transform: `scaleX(0)`,
        transformOrigin: 'center left',
      }
    },
    durationClass() {
      switch (this.snackbar.type) {
        case 'success': return 'bg-green-600';
        case 'error': return 'bg-red-600';
        case 'info': return 'bg-blue-600';
        case 'warning': return 'bg-yellow-600';
        default: return 'bg-blue-600';
      }
    },
    grmSnackbarClass() {
      switch (this.snackbar.type) {
        case 'success': return 'bg-green-100';
        case 'error': return 'bg-red-100';
        case 'info': return 'bg-blue-100';
        case 'warning': return 'bg-yellow-100';
        default: return 'bg-blue-100';
      }
    },
    grmSnackbarStyle() {
      let gap = 8;
      let height = (this.index + 1) * gap;

      this.snackbars[this.snackbar.position].forEach((snackbar, index) => {
        if (index < this.index) {
          const snackbarEl = document.querySelector(`[data-snackbar-id="${snackbar.id}"]`);
          height += snackbarEl?.offsetHeight || 0;
        }
      })

      const position = this.snackbar.position.includes('top') ? 'top' : 'bottom';
      return {
        'max-width': `calc(100vw - ${ this.isMobile ? '2' : this.isOpenExtendMenu ? '30' : '6' }rem)`,
        [position]: `${height}px`,
      }
    },
    messageClass() {
      switch (this.snackbar.type) {
        case 'success': return 'text-green-700';
        case 'error': return 'text-red-700';
        case 'info': return 'text-blue-700';
        case 'warning': return 'text-yellow-700';
        default: return 'text-blue-700';
      }
    },
    closeBtnClass() {
      switch (this.snackbar.type) {
        case 'success': return 'hover:bg-green-200';
        case 'error': return 'hover:bg-red-200';
        case 'info': return 'hover:bg-blue-200';
        case 'warning': return 'hover:bg-yellow-200';
        default: return 'hover:bg-blue-200';
      }
    },
    isMobile() {
      return Device.isMobile();
    }
  },
  mounted() {
    if (!this.snackbar.duration) {
      return;
    }

    this.addCustomEventListeners();

    setTimeout(() => {
      this.$refs.duration.style.transform = 'scaleX(1)';
    });

    setTimeout(() => {
      this.close();
    }, this.snackbar.duration);
  },
  destroyed() {
    const hasActions = this.snackbar.actions?.length > 0
    if (!hasActions) {
        return;
    }
    this.snackbar.actions.forEach((action, i) => {
        const target = document.querySelector(action.target);
        target?.removeEventListener(action.handler, this[`actionFunc${i}`]);
    });
  },
  methods: {
    close() {
      this.$parent.$parent.removeSnackbar({id: this.snackbar.id, position: this.snackbar.position});
    },
    showAllMessage() {
      // this.$nextTick(() => {
      //   if (this.isShowAllMessage) {
      //     this.isShowAllMessage = false;
      //     return;
      //   }
      //
      //   if (this.$refs.message.clientWidth >= this.$refs.message.scrollWidth) {
      //     return;
      //   }
      //
      //   this.isShowAllMessage = true;
      // });
    },
    addCustomEventListeners() {
      const hasActions = this.snackbar.actions?.length > 0
      if (!hasActions) {
        return;
      }
      this.snackbar.actions.forEach((action, i) => {
        const target = document.querySelector(action.target);
        if (!target) {
          return;
        }

        this[`actionFunc${i}`] = () => {
          action.func();

          if (action.afterHide) {
            this.close();
          }
        }

        target.addEventListener(action.handler, this[`actionFunc${i}`])
      })
    }
  }
}
</script>